"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.18 10.931h-1.428l-1.129 2.658a.625.625 0 01-1.18-.071l-1.386-4.814-1.68 6.638a.627.627 0 01-.608.473h-.01a.627.627 0 01-.602-.492l-1.035-4.7H6.82a.627.627 0 010-1.253h1.807c.294 0 .549.204.612.492l.573 2.604 1.6-6.316a.627.627 0 011.21-.02l1.538 5.343.6-1.414a.627.627 0 01.578-.382h1.843a.627.627 0 010 1.254zM21 2.665c0-.294-.018-.587-.115-.87-.132-.384-.402-.61-.788-.711A2.973 2.973 0 0019.338 1H4.663c-.291 0-.582.021-.864.115-.386.128-.612.4-.715.785a1.996 1.996 0 00-.071.486c-.001.04-.009.078-.013.117V17.63c.014.124.029.247.042.371.02.2.08.388.21.543.146.172.334.29.542.378l3.714 1.558 3.651 1.531c.126.053.25.113.376.162.35.136.692.107 1.033-.04 2.064-.884 4.14-1.739 6.21-2.61.474-.2.947-.401 1.422-.597.185-.076.35-.182.493-.319a.876.876 0 00.251-.508c.037-.23.056-.46.056-.692l-.001-14.743z" }), "AnalyticsShield");
//# sourceMappingURL=AnalyticsShield.js.map